<div class="container-pagina-espacios">
  <div class="descripcion-pagina">
    <b>Listado ocupantes:</b> Selecciona la fila de cada ocupante para ampliar su información.
  </div>
  <div [ngClass]="{'hidden-espacios': environment.production}" class="contenido-tablas">
    <app-tabla-general [displayedColumns]="displayedColumns" [moduloActual]="'lugares'"></app-tabla-general>
    @if (!environment.production) {
      <app-listar-espacios></app-listar-espacios>
    }
    <router-outlet></router-outlet>
  </div>
</div>
